import Action from '@/types/Action';
import { List } from '@/types/List';
import Tab from '@/types/Tab';

import insertTab from '../mutateSession/insertTab';

const anticipateRecordSearchDetail = (searchData: any) =>
{
	const detailAction: Partial<Action> = {
		id: '-1',
		action_type: 'record_search_results',
		...searchData,
		search: searchData,
		data: {
			...searchData,
			search: searchData,
			anticipate: true
		},
		action_id: '-1',
		tab_id: '-1'
	};

	const newTab: Tab = {
		id: '-1',
		actions: [detailAction as Action],
		session_id: '-1',
		title: 'Detail',
		created_at: ''
	};

	//console.log('Anticipating Compass detail', newTab, searchData);

	insertTab(newTab);
};

export default anticipateRecordSearchDetail;
